import m from "mithril";
import i18n from "../../../shared/i18n/i18n";
const {Sortable} = require("sortablejs");

const OptionsEditor = {
    view: function (vnode) {
        const {options, optionInput, onInput, onAdd, onRemove, onSort} = vnode.attrs;

        return [
            m(".form-label", i18n.t("options")),
            m(".form-section.with-button", [
                m("input[type=text]", {
                    value: optionInput,
                    oninput: function () {
                        onInput(this.value);
                    },
                    onkeyup: function (e) {
                        if (e.key === "Enter") {
                            onAdd();
                        }
                    }
                }),
                m("button.active", {
                    disabled: !optionInput,
                    onclick: onAdd
                }, "+")
            ]),
            m(".option-list", {
                oncreate: function (vnode) {
                    Sortable.create(vnode.dom, {
                        handle: ".drag-handle",
                        animation: 100,
                        onSort: onSort
                    });
                }
            }, options.map(function (option) {
                return m("div.flex-row", {key: option.id, id: option.id, style: "align-items: center;"}, [
                    m("i.icon-arrange.drag-handle", {style: "cursor: grab; margin-right: 4px;"}),
                    m("button.btn-text", {
                        onclick: function () {
                            onRemove(option.id);
                        }
                    }, "x"),
                    option.value
                ]);
            })),
            options.length > 0 ? m("hr") : ""
        ];
    }
};

export default OptionsEditor;
